let tokenObject = {
  token: 'ma-token',
  name:'ma-name',
  stores:'ma-stores',
  shopCode:'ma-shopCode',
  plat:'ma-plat',
  userId: 'ma-userId',
  realName: 'ma-realName',
  shopName: 'ma-shopName'
}

// export function getSession(key) {
//   return sessionStorage.getItem(tokenObject[key])
// }

// export function setSession(key, token) {
//   return sessionStorage.setItem(tokenObject[key], token)
// }

// export function removeSession(key) {
//   return sessionStorage.removeItem(tokenObject[key])
// }
export function getSession(key) {
  return localStorage.getItem(tokenObject[key])
}

export function setSession(key, token) {
  return localStorage.setItem(tokenObject[key], token)
}

export function removeSession(key) {
  return localStorage.removeItem(tokenObject[key])
}



// WEBPACK FOOTER //
// ./src/utils/auth.js